<template>
  <div class="helping">
    <three-dots class="dots"/>
    <div class="title">Помогаю решить</div>
    <div class="problems">
      <b-row class="px-0 mx-0 pro justify-content-lg-start justify-content-md-center justify-content-sm-start">
        <b-col cols="12" sm="6" xs="12" md="4" lg="3" xl="3" class="px-0 card-opas">
          <b-card
            overlay
            :img-src="require('@/assets/help1.png')"
            img-alt="Card Image"
            text-variant="white"
            title="Сексуальная неудовлетворенность"
          >
            <b-card-text>
               Развитие чувственности и сексуальности
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="12" sm="6" xs="12" md="4" lg="3" xl="3" class="px-0 card-opas">
          <b-card
            overlay
            :img-src="require('@/assets/help2.png')"
            img-alt="Card Image"
            text-variant="white"
            title="Стыд и вина"
          >
            <b-card-text>
              Повышение самооценки и принятие себя
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="12" sm="6" xs="12" md="4" lg="3" xl="3" class="px-0 card-opas">
          <b-card
            overlay
            :img-src="require('@/assets/help3.png')"
            img-alt="Card Image"
            text-variant="white"
            title="Психологические травмы"
          >
            <b-card-text>
              Нахождение ресурсов в прожитых переживаниях
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="12" sm="6" xs="12" md="4" lg="3" xl="3" class="px-0 card-opas">
          <b-card
            overlay
            :img-src="require('@/assets/help4.png')"
            img-alt="Card Image"
            text-variant="white"
            title="Усталость"
          >
            <b-card-text>
              Забота о внутреннем ребёнке 
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="12" sm="6" xs="12" md="4" lg="3" xl="3" class="px-0 card-opas">
          <b-card
            overlay
            :img-src="require('@/assets/help5.png')"
            img-alt="Card Image"
            text-variant="white"
            title="Конфликты на работе"
          >
            <b-card-text>
                Выстраивание здоровых психологических границ
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="12" sm="6" xs="12" md="4" lg="3" xl="3" class="px-0 card-opas">
          <b-card
            overlay
            :img-src="require('@/assets/help6.png')"
            img-alt="Card Image"
            text-variant="white"
            title="Сложные отношения с мамой"
          >
            <b-card-text>
                 Здоровая сепарация от матери 
            </b-card-text>
          </b-card>
        </b-col>

        <b-col cols="12" sm="6" xs="12" md="4" lg="3" xl="3" class="px-0 card-opas">
          <b-card
            overlay
            :img-src="require('@/assets/help7.png')"
            img-alt="Card Image"
            text-variant="white"
            title="Кризис в отношениях"
          >
            <b-card-text>
              Здоровое разрешение конфликтов
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="12" sm="6" xs="12" md="4" lg="3" xl="3" class="px-0 card-opas">
          <b-card
            overlay
            :img-src="require('@/assets/help8.png')"
            img-alt="Card Image"
            text-variant="white"
            title="Не могу достичь успеха"
          >
            <b-card-text>
              Постановка и достижение цели
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import ThreeDots from '@/components/icons/ThreeDots';
  export default {
    name: "Helping",
    components: {ThreeDots}
  }
</script>

<style lang="scss">
  .helping {
    padding: 64px 0;
    .problems {
      .card {
        border-radius: 0;
        border: none;
        &-img {
          border-radius: 0 !important;
        }
        &-img-overlay {
          top: unset;
        }
      }
    }
  }
  .problems {
    .card {
      .card-body {
        font-family: 'Raleway', sans-serif;
        .card-title {
          font-size: 32px;
          font-weight: normal;
          color: #ffffff;
        }
        .card-text {
          font-size: 17px;
          color: #ffffff;
        }
      }
    }
  }
  @media screen and (max-width: 550px){
    .helping {
      padding: 24px 0;
      .title {
        margin-bottom: 32px;
      }
    }
  }
  @media screen and (max-width: 1460px) {
    .problems {
      .card {
        .card-body {
          .card-title {
            font-size: 24px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1200px){
    .helping {
      .card {
        .card-body {
          .card-title {
            font-size: 24px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 928px){
    .helping {
      display: none;
    }
  }
</style>